import { captureException } from '@sentry/react'
import { useQuery } from '@tanstack/react-query'
import { query } from 'config/api'
import { useEffect } from 'react'
import { createGradeOverrideMap } from 'util/gradeOverrides'

export function useGradeOverrides(
  sectionId: string,
  assignmentId?: string,
  enabled = true
) {
  const result = useQuery({
    ...query.api.v1.sections.gradeOverrides.index.queryOptions({
      params: { sectionId },
      query: { assignmentId },
    }),
    enabled: enabled && Boolean(sectionId),
    staleTime: 30_000,
  })

  const responseError =
    result.error ??
    (result.data && 'error' in result.data ? result.data.error : null)

  useEffect(() => {
    if (!responseError) return

    captureException(responseError, {
      tags: { feature: 'grade-overrides' },
      extra: { sectionId, assignmentId },
    })
  }, [assignmentId, responseError, sectionId])

  const overrides = result.data && !('error' in result.data) ? result.data : []

  return {
    ...result,
    overrideMap: createGradeOverrideMap(overrides),
  }
}

export function gradeOverridesQueryFilter() {
  return query.api.v1.sections.gradeOverrides.index.queryFilter()
}
